/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogTitleComponent } from '@ng-falcon/dialog/dialog-title/dialog-title.component';
import { MatDialogModule } from '@angular/material/dialog';
import { UIRouterModule } from '@uirouter/angular';
import { NgfRichTextModule } from '@ng-falcon/ngf-rich-text/ngf-rich-text.module';
import { SkeletonListComponent } from '../common/components/skeleton-list/skeleton-list.component';
import { ViewPickerComponent } from '../common/components/view-picker/view-picker.component';
import { SharedModule } from '../shared/shared.module';
import { CommonComponentsModule } from '../common/components/common-components.module';
import { CommunityModule } from '../common/community/community.module';
import { CommunityFeedModule } from '../common/community/feed/community-feed.module';
import { UtCategoryLinkModule } from '../common/community/feed/category-link/category-link.module';
import { EmojiHtmlPipe } from '../pipes/emoji-html.pipe';
import { CommunityProfileComponent } from './community-profile.component';
import { CommunityProfileHeaderComponent } from './header/community-profile-header.component';
import { CommunityProfileOverviewComponent } from './overview/community-profile-overview.component';
import { CommunityProfilePostsComponent } from './posts/community-profile-posts.component';
import { CommunityProfileActivityListComponent } from './activity-list/community-profile-activity-list.component';
import { CommunityProfileActivityCardComponent } from './activity-card/community-profile-activity-card.component';
import { CommunityProfilePeopleComponent } from './people/community-profile-people.component';
import { CommunityProfileEditDialogComponent } from './edit-dialog/community-profile-edit-dialog.component';
import { CommunityProfilePinActionComponent } from './pin-action/community-profile-pin-action.component';
import { CommunityProfilePinnedLabelComponent } from './pinned-label/community-profile-pinned-label.component';
import { CommunityProfileMentionDialogComponent } from './mention-dialog/community-profile-mention-dialog.component';

// Not standalone, for the same reason as CommunityFeedModule: the follow button and feed card come from
// NgModules that pull in UpgradeModule.
@NgModule({
  imports: [
    CdkMenuModule,
    CommonModule,
    FormsModule,
    MatDialogModule,
    UIRouterModule,
    NgfRichTextModule,
    SharedModule,
    CommonComponentsModule,
    CommunityModule,
    CommunityFeedModule,
    UtCategoryLinkModule,
    DialogTitleComponent,
    SkeletonListComponent,
    ViewPickerComponent,
    CommunityProfilePinnedLabelComponent,
    EmojiHtmlPipe,
  ],
  declarations: [
    CommunityProfileComponent,
    CommunityProfileHeaderComponent,
    CommunityProfileOverviewComponent,
    CommunityProfilePostsComponent,
    CommunityProfileActivityListComponent,
    CommunityProfileActivityCardComponent,
    CommunityProfilePeopleComponent,
    CommunityProfileEditDialogComponent,
    CommunityProfileMentionDialogComponent,
    CommunityProfilePinActionComponent,
  ],
  exports: [CommunityProfileComponent],
})
class CommunityProfileModule {}

export { CommunityProfileModule };
